import { render } from "./Lightbox.vue?vue&type=template&id=0923a3a3"
import script from "./Lightbox.vue?vue&type=script&lang=js"
export * from "./Lightbox.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pmerkuloff/Web/hlv/FRONT/hpanel/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__